<template>
  <v-dialog v-model="dialog" persistent max-width="680" :fullscreen="fromSeller && $store.getters.mobile">
    <v-card :key="key">
      <v-app-bar flat :color="fromSeller ? 'primary' : 'orange'">
        <v-toolbar-title class="text-h6 white--text pl-0">
          {{ fromSeller ? "Pedidos pendientes" : $t("pending_orders") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" icon @click="$emit('close')" :title="$t('Cancel')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card-text :style="fromSeller && $store.getters.mobile ? '' : 'max-height: 60vh; overflow-y: auto'">
        <v-row class="pt-4">
          <v-col cols="12" sm="12">
            <div :key="'pend' + $store.getters.orderChanged">
              <div v-if="loading" class="text-center py-8 grey--text">Cargando…</div>
              <div v-else-if="pedidosOrdenados.length === 0" class="text-center grey--text py-10">
                <v-icon large color="grey lighten-1">mdi-clipboard-check-outline</v-icon>
                <div class="mt-2 font-weight-bold">{{ fromSeller ? "No tienes pedidos pendientes" : "No hay pedidos pendientes" }}</div>
                <div class="caption">{{ fromSeller ? "Aquí aparecen los pedidos que enviaste y aún no se cobran." : "Aquí aparecen los pedidos abiertos que aún no se cobran." }}</div>
              </div>
              <div v-for="o in pedidosOrdenados" :key="o.id || o.local_reference" class="pendiente"
                :class="{ 'pendiente--rechazado': esRechazado(o), 'pendiente--devuelto': esDevuelto(o) }" @click="esRechazado(o) ? null : setCurrentOrder(o)">
                <div class="pendiente__cabecera">
                  <v-chip small dark :color="tipo(o).color">
                    <v-icon left small>{{ tipo(o).icono }}</v-icon>{{ tipo(o).texto }}
                  </v-chip>
                  <span class="pendiente__mesero" v-if="!fromSeller && o.data_seller && o.data_seller.name"><v-icon small>mdi-account-outline</v-icon> {{ o.data_seller.name }}</span>
                  <v-spacer></v-spacer>
                  <v-chip small outlined :color="estado(o).color">{{ estado(o).texto }}</v-chip>
                </div>
                <div class="pendiente__cliente" v-if="nombreCliente(o)">{{ nombreCliente(o) }}</div>
                <div class="pendiente__dato" v-if="o.data_customer && o.data_customer.phone">
                  <v-icon x-small>mdi-phone-outline</v-icon> {{ o.data_customer.phone }}
                </div>
                <div class="pendiente__dato" v-if="direccion(o)">
                  <v-icon x-small>mdi-map-marker-outline</v-icon> {{ direccion(o) }}
                </div>
                <div class="pendiente__dato" v-if="o.data_domiciliary && o.data_domiciliary.name">
                  <v-icon x-small>mdi-moped-outline</v-icon> Domiciliario: {{ o.data_domiciliary.name }}
                </div>
                <div class="pendiente__lineas" v-if="lineas(o).length">
                  <div v-for="(l, i) in lineas(o)" :key="i" class="pendiente__linea">
                    <div class="pendiente__nombre">
                      <span class="pendiente__cantidad">{{ l.cantidad }}×</span> {{ l.nombre }}
                      <span class="pendiente__precio">{{ $filters.currency(l.total, 0) }}</span>
                    </div>
                    <div class="pendiente__detalle" v-for="(d, j) in l.detalle" :key="j">{{ d }}</div>
                    <div class="pendiente__nota" v-if="l.nota"><v-icon x-small color="amber darken-3">mdi-comment-text-outline</v-icon> {{ l.nota }}</div>
                  </div>
                </div>
                <div class="pendiente__rechazo" v-if="esRechazado(o)">
                  <strong>La caja rechazó este pedido.</strong>
                  <div>Motivo: {{ o.cancellation_reason || "sin motivo" }}</div>
                  <v-btn small depressed color="red darken-1" class="white--text mt-2" @click.stop="entendido(o)">Entendido</v-btn>
                </div>
                <div class="pendiente__rechazo pendiente__devuelto" v-if="esDevuelto(o)">
                  <strong>La caja te devolvió este pedido para corregirlo.</strong>
                  <div>Motivo: {{ motivoDevolucion(o) || "sin motivo" }}</div>
                  <div v-if="lineasDevueltas(o).length">Cambiar: <strong>{{ lineasDevueltas(o).map((l) => l.name).join(", ") }}</strong></div>
                  <div class="caption">Tócalo para abrirlo, cambia lo que haga falta y vuelve a enviarlo.</div>
                </div>
                <div class="pendiente__rechazo pendiente__devuelto" v-if="lineasImposibles(o).length">
                  <strong>No se puede preparar:</strong>
                  <div v-for="(l, i) in lineasImposibles(o)" :key="'imp' + i">{{ l.name }} · {{ l.reason || "sin motivo" }}</div>
                  <div class="caption">Tócalo, quita ese producto, agrega otro y vuelve a enviarlo.</div>
                </div>
                <div class="pendiente__pie">
                  <span>{{ productos(o) }} · <strong class="pendiente__total">{{ $filters.currency(getItemPriceTotalWithAdds(o), 0) }}</strong></span>
                  <span class="grey--text text--darken-1">{{ hace(o) }}</span>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          dark
          color="primary"
          outlined
          @click="$emit('close')"
          :title="$t('Cancel')"
        >
          {{ fromSeller ? "Cerrar" : $t("Cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style>
.pendiente {
  margin-bottom: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  cursor: pointer;
}

.pendiente--rechazado {
  border-color: #e53935;
  background: #fff5f5;
  cursor: default;
}

.pendiente--devuelto {
  border-color: #f4511e;
  background: #fff8f5;
}

.pendiente__devuelto {
  color: #bf360c;
  background: rgba(244, 81, 30, 0.08);
}

.pendiente__rechazo {
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 0.9rem;
  color: #b71c1c;
  background: rgba(229, 57, 53, 0.08);
}

.pendiente__cabecera {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.pendiente__cliente {
  font-size: 1.05rem;
  font-weight: 700;
}

.pendiente__dato {
  margin-top: 2px;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.7);
}

.pendiente__pie {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px dashed rgba(0, 0, 0, 0.15);
}

.pendiente:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.pendiente__mesero {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.7);
}

.pendiente__lineas {
  margin-top: 8px;
}

.pendiente__linea {
  padding: 6px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.pendiente__linea:last-child {
  border-bottom: 0;
}

.pendiente__nombre {
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-size: 1rem;
  font-weight: 700;
}

.pendiente__cantidad {
  color: #1976d2;
}

.pendiente__precio {
  margin-left: auto;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
}

.pendiente__detalle {
  margin-top: 2px;
  padding-left: 10px;
  border-left: 3px solid rgba(25, 118, 210, 0.35);
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.7);
}

.pendiente__nota {
  margin-top: 4px;
  font-size: 0.9rem;
  font-style: italic;
  color: rgba(0, 0, 0, 0.7);
}

.pendiente__total {
  font-size: 1.25rem;
  font-weight: 800;
}

.bg_modal {
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)) 0% 0% /
    cover no-repeat;
}
</style>
<script>
import { esRechazado, esDevuelto, motivoDevolucion, lineasDevueltas, lineasImposibles, marcarVisto, sinVer } from "@/plugins/pedidos-rechazados";

export default {
  components: {},
  name: "CartPendingOrders",
  data: () => ({
    orders: [],
    key: 0,
    loading: false,
  }),
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    fromSeller: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // Los más recientes primero.
    pedidosOrdenados() {
      return [...this.orders].sort((a, b) => String(b.opening_date || "").localeCompare(String(a.opening_date || "")));
    },
  },
  methods: {
    tipo(o) {
      if (o.is_domicile) return { texto: "Domicilio", icono: "mdi-moped-outline", color: "deep-orange darken-1" };
      if (o.name_table) return { texto: o.name_table, icono: "mdi-table-furniture", color: "primary" };
      if (o.store_pickup) return { texto: "Para llevar", icono: "mdi-bag-personal-outline", color: "teal darken-1" };
      return { texto: "Sin mesa", icono: "mdi-help-circle-outline", color: "grey" };
    },
    estado(o) {
      const estados = {
        create: { texto: "Sin enviar", color: "grey darken-1" },
        pending: { texto: "Esperando a la caja", color: "amber darken-3" },
        received: { texto: "En cola de cocina", color: "blue darken-1" },
        preparing: { texto: "Preparando", color: "deep-orange darken-2" },
        prepared: { texto: "Listo para servir", color: "green darken-1" },
        annulled: { texto: "Rechazado", color: "red darken-1" },
        returned: { texto: "Devuelto · corregir", color: "deep-orange darken-2" },
      };
      if (o.order_status === "pending" && !o.from_seller) {
        return { texto: "Cuenta impresa", color: "blue-grey darken-1" };
      }
      return estados[o.order_status] || { texto: o.order_status || "—", color: "grey" };
    },
    nombreCliente(o) {
      const c = o.data_customer;
      if (!c) return "";
      return [c.first_name || c.name || c.business_name, c.last_name].filter(Boolean).join(" ");
    },
    direccion(o) {
      if (o.data_customer && o.data_customer.address) return o.data_customer.address;
      const d = o.shipping_address;
      if (!d) return "";
      return typeof d === "string" ? d : d.address || "";
    },
    // Las líneas del pedido en texto simple, con variante, opciones y notas.
    lineas(o) {
      let items = o.data_items;
      if (typeof items === "string") {
        try {
          items = JSON.parse(items);
        } catch (e) {
          items = [];
        }
      }
      return (items || []).map((l) => {
        const detalle = [];
        if (l.product_variant && l.product_variant.name) detalle.push(l.product_variant.name);
        const opciones = l.options || {};
        for (const k of Object.keys(opciones)) {
          const op = opciones[k];
          if (!op || op.option_type !== "custom") continue;
          const valor = Array.isArray(op.value) ? op.value.join(", ") : op.value;
          if (valor) detalle.push(op.name + ": " + valor);
        }
        for (const sub of l.sub_items || []) {
          detalle.push(sub.quantity + " × " + sub.product.name);
        }
        return {
          cantidad: parseFloat(l.quantity) || 0,
          nombre: (l.product && l.product.name) || l.product_name || "Producto",
          total: l.total_amount,
          detalle,
          nota: l.note,
        };
      });
    },
    productos(o) {
      let lineas = o.data_items;
      if (typeof lineas === "string") {
        try {
          lineas = JSON.parse(lineas);
        } catch (e) {
          lineas = [];
        }
      }
      const n = Math.ceil((lineas || []).reduce((t, l) => t + (parseFloat(l.quantity) || 0), 0));
      return n + (n === 1 ? " producto" : " productos");
    },
    hace(o) {
      if (!o.opening_date) return "";
      const t = Date.parse(String(o.opening_date).replace(" ", "T"));
      if (isNaN(t)) return "";
      const min = Math.max(0, Math.round((Date.now() - t) / 60000));
      if (min < 1) return "ahora";
      if (min < 60) return "hace " + min + " min";
      const h = Math.floor(min / 60);
      return "hace " + h + (h === 1 ? " hora" : " horas");
    },
    async getPendingOrders() {
      this.loading = true;
      this.orders = [];
      let params = {};
      if (this.fromSeller) {
        let user = this.$store.getters.user;
        params["bus_person_seller_id"] = user.id;
        // También lo que la caja rechazó hace poco, para que el mesero lo vea con su motivo.
        params["incluir_rechazados"] = true;
      }
      // let installation = this.$store.getters.installation;
      // if (installation) {
      //   params['cash_register'] = installation.cash_id;
      // }
      const pedidos = await this.$pos.getOpenedOrders(params);
      // Un rechazo que el mesero ya vio («Entendido») no se vuelve a mostrar.
      this.orders = (pedidos || []).filter((o) => !esRechazado(o) || sinVer(o));
      this.loading = false;
    },
    cancel() {
      this.clear();
      this.searched = false;
      this.key++;
      this.$emit("cancel");
    },
    clear() {},
    esRechazado,
    esDevuelto,
    motivoDevolucion,
    lineasDevueltas,
    lineasImposibles,
    entendido(o) {
      marcarVisto(o.id);
      this.orders = this.orders.filter((x) => x.id !== o.id);
      this.$emit("visto", o);
    },
    setCurrentOrder(item) {
      if (esDevuelto(item)) {
        // Lo devuelto no llegó a cocina: el mesero puede cambiar todas las líneas, aunque ya se hubieran enviado.
        let lineas = item.data_items;
        if (typeof lineas === "string") {
          try {
            lineas = JSON.parse(lineas);
          } catch (e) {
            lineas = [];
          }
        }
        const marcadas = lineasDevueltas(item).map((l) => l.index);
        item = {
          ...item,
          data_items: (lineas || []).map((l, i) => ({ ...l, save_from_seller: false, printed: false, devuelta: marcadas.includes(i) })),
        };
      }
      this.$pos.setCurrentOrder(item);
      this.$emit("cancel");
    },
    getItemPriceTotalWithAdds(item) {
      return (
        parseFloat(item.total_to_pay) +
        parseFloat(item.price_tip) +
        parseFloat(item.price_domicile)
      );
    },
  },
};
</script>